import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Device } from '@ionic-native/device';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { VERSION, STORES } from '@env';

@Injectable()
export class DeviceProvider {

  private jugador: Jugador;

  constructor(
    public http: HttpClient,
    private platform: Platform,
    private device: Device,
    private authProvider: AuthProvider,) {
  }

  init() {
    if(this.platform.is('cordova')) {
      this._init();
    }
  }

  async _init() {
    this.jugador = await this.authProvider.getSession();

    let params: any = {};

    params.cordova = this.device.cordova;
    params.model = this.device.model;
    params.platform = this.device.platform;
    params.uuid = this.device.uuid;
    params.version = this.device.version;
    params.manufacturer = this.device.manufacturer;
    params.isVirtual = this.device.isVirtual;
    params.serial = this.device.serial;
    params.versionAPP = VERSION;
    params.jugador = this.jugador._id;
    params.correo = this.jugador.correo;

    await this.authProvider.guardaInfoDevice(params);
  }

  generaURLStore() {
    if(this.platform.is('android')) {
      return STORES.ANDROID;
    } else if ( this.platform.is('ios') ) {
      return STORES.IOS
    }

    return STORES.WEB;
  }

  async checkNewVersion() {
    return this._checkNewVersion();
  }

  private async _checkNewVersion() {
    let os = 'unknow';
    if(!this.platform.is('cordova')){
      os = 'web';
    } else if(this.platform.is('android')) {
      os = 'android'
    } else if ( this.platform.is('ios') ) {
      os = 'ios'
    }

    const parameters = {
      currentVersion: VERSION,
      os: os
    };

    return await this.authProvider.checkNewVersion(parameters);
  }

}



// WEBPACK FOOTER //
// ./src/providers/device/device.ts